export const numberInCentsToDisplay = (priceInCents: number | null): string | null => {
  if (priceInCents) {
    const normalPriceHasDecimals = String(priceInCents).slice(-2) !== "00";
    return (priceInCents / 100).toFixed(normalPriceHasDecimals ? 2 : 0);
  }

  return null;
};
